import { http } from './http';

const SESSION_KEY = 'simimovies.visitor.session.v1';

function getSessionId() {
  try {
    let id = window.localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return '';
  }
}

export function trackOfferClick({ category, tmdbId, language, offerIndex, offerTitle, offerUrl } = {}) {
  if (typeof window === 'undefined' || !offerUrl) return Promise.resolve();
  return http
    .post('/api/v1/offers/click', {
      category,
      tmdbId,
      language,
      offerIndex,
      offerTitle,
      offerUrl,
      sessionId: getSessionId(),
    })
    .catch(() => null);
}
